<template lang="pug">
	.preview-portfolio(v-if="showed" @click="hide()")
		.card(@click.stop)
			.card-header
				i.fa.fa-map-o
				span Portfolio
			.card-body.collapse.show
				//InputSelect(v-on:change="setCategory($event)" default="" :value="selectedCategory" :values="categories" :options="{editable: false, displayedValueTransform: v => Metadata.GenreCategoriesByCodename[v]?.title || ''}" theme="dark-medium")
				.category-types.table.tabs
					.category-type-line.table-row
						.category-type.table-cell.tab(v-for="category in categoryChunks[0]" :class="{selected: selectedCategories.includes(category.codename)}" @click="setCategory(category.codename)")
							.title {{category.title}}
							i.fa.fa-plus.combine(v-if="!selectedCategories.includes(category.codename)" :class="{disabled: !canCombineCategory(category.codename)}" @click.stop="addCategoryToFilter(category.codename)" :title="canCombineCategory(category.codename) ? 'Add to category filter' : 'No playables for this combination'")
					.category-type-line.table-row
						.category-type.table-cell.tab(v-for="category in categoryChunks[1]" :class="{selected: selectedCategories.includes(category.codename)}" @click="setCategory(category.codename)")
							.title {{category.title}}
							i.fa.fa-plus.combine(v-if="!selectedCategories.includes(category.codename)" :class="{disabled: !canCombineCategory(category.codename)}" @click.stop="addCategoryToFilter(category.codename)" :title="canCombineCategory(category.codename) ? 'Add to category filter' : 'No playables for this combination'")
					.category-type-line.table-row
						.category-type.table-cell.tab(v-for="category in categoryChunks[2]" :class="{selected: selectedCategories.includes(category.codename)}" @click="setCategory(category.codename)")
							.title {{category.title}}
							i.fa.fa-plus.combine(v-if="!selectedCategories.includes(category.codename)" :class="{disabled: !canCombineCategory(category.codename)}" @click.stop="addCategoryToFilter(category.codename)" :title="canCombineCategory(category.codename) ? 'Add to category filter' : 'No playables for this combination'")
				.form-line
					.tabs(v-if="genres.length")
						.tab(v-for="genre in genres" :class="{selected: selectedGenres.includes(genre.codename)}" @click="setGenre(genre.codename)")
							.title {{genre.title}}
							i.fa.fa-plus.combine(v-if="!selectedGenres.includes(genre.codename)" :class="{disabled: !canCombineGenre(genre.codename)}" @click.stop="addGenreToFilter(genre.codename)" :title="canCombineGenre(genre.codename) ? 'Add to genre filter' : 'No playables for this combination'")
					.tabs.formats
						.tab(v-for="genre in genreFormats" :class="{selected: selectedFormats.includes(genre.codename)}" @click="setFormat(genre.codename)")
							.title {{genre.title}}
				draggable.previews.separator(:list="previews" :disabled="!sortingMode" :class="{sorting: sortingMode}" animation="200" @end="saveOrder")
					.preview(v-for="preview in previews" :key="preview.id" @click="openPreview(preview)")
						i.fa.favorite-star(:class="preview['is_favorite'] ? 'fa-star' : 'fa-star-o'" :title="preview['is_favorite'] ? 'Remove from favorites' : 'Mark as favorite'" @click.stop="toggleFavorite(preview)")
						.preview-inner
							.preview-icon
								img(v-if="preview.options?.screenshotExist" :src="Preview.getPreviewScreenshotUrl(preview)")
							.preview-video
								video(v-if="preview.options?.videoExist" :src="Preview.getPreviewVideoUrl(preview)" @mouseenter="playVideo($event)" @mouseleave="stopVideo($event)" playsinline loop muted)
				.form-actions
					button.btn.btn-primary(type="button" v-on:click="createPreviewFromUrl()" :disabled="!url || !selectedGenres.length")
						i.fa.fa-plus
						span Add preview by url
					input.form-control.url(size="16" type="text" v-model="url" placeholder="External preview url")
					//button.btn.btn-danger(v-if="preview" type="button" @click="deletePreview($event)")
						i.fa.fa-remove
						span Delete preview
					button.btn(type="button" :class="sortingMode ? 'btn-warning' : 'btn-primary'" @click="toggleSortingMode()")
						i.fa.fa-sort
						span {{sortingMode ? 'Done sorting' : 'Sort previews'}}
					button.btn.btn-primary(type="button" @click="publishPortfolio()" :disabled="publishState === 'publishing'")
						i.fa.fa-upload
						span {{publishTitle}}
					button.btn.btn-dark(type="button" @click="hide()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen'

	import { Preview }				from '../../services/Preview'

	import InputSelect			from './../Editor/Controls/InputSelect'

	import draggable			from "vuedraggable";

	export default {
		name: "PreviewPortfolio",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Previews Added",
				"Preview Changed: [Genres]",
				"Preview Changed: [options.screenshotExist]",
				"Preview Changed: [options.videoExist]",
				"Preview Changed: [options.portfolioOrder]",
				"Preview Changed: [is_favorite]",
				"Preview Removed"
			],
			events: {
				"Server Data:PortfolioPublished": function(data) {

					this.publishState = 'published';
					this.publishedCount = data.count;

					setTimeout(() => this.publishState = '', 3000);

				},
				"Show Portfolio": function(preview) {

					this.Preview = Preview;

					this.preview = preview;

					this.sortingMode = false;

					this.show();

					Server.sendToSocket({
						Navigation: {
							title: 'Page',
							description: 'portfolio',
							data: {}
						}
					});

				}
			}
		},
		components: {
			InputSelect,
			draggable
		},
		data() {

			this.categoryChunks = [];
			this.genres = [];
			this.previews = [];
			this.tmpPreviews = []; // Превью помеченные как "в портфолио" но не находящиеся ни в одном активном жанре
			this.initialized = false;
			this.lastCategoriesKey = '';
			this.activeGenresByCategory = {};

			return {
				selectedCategories: [],
				selectedGenres: [],
				selectedFormats: [],
				sortingMode: false,
				url: '',
				publishState: '',
				publishedCount: 0
			}

		},
		computed: {
			publishTitle() {

				if (this.publishState === 'publishing') return 'Publishing...';
				if (this.publishState === 'published') return `Published (${this.publishedCount})`;

				return 'Publish portfolio';

			}
		},
		methods: {
			collectData() {

				this.categories = _.map(_.orderBy(_.filter(Metadata.GenreCategories, category => category.active), "priority"), category => { return {title: category.title, codename: category.codename, data: {itemValue: category.codename}} });

				const needInit = !this.initialized;
				this.initialized = true;

				// Если первое открытие портфолио, то выбираем первую категорию, дальше сохраняем выбор
				if (needInit) this.selectedCategories = this.categories[0] ? [this.categories[0].codename] : [];

				const singleCategory = this.selectedCategories.length === 1 ? this.selectedCategories[0] : null;

				this.genres = singleCategory
					? _.orderBy(_.filter(Metadata.Genres, genreProps => genreProps['category_codename'] === singleCategory && genreProps.active), "priority")
					: [];

				const categoriesKey = this.selectedCategories.slice().sort().join('|');

				if (needInit) this.selectedGenres = this.genres[0] ? [this.genres[0].codename] : [];
				else if (this.lastCategoriesKey !== categoriesKey) {

					this.selectedGenres = this.selectedGenres.filter(codename => this.selectedCategories.includes(Metadata.GenresByCodename?.[codename]?.['category_codename']));

					if (!this.selectedGenres.length && singleCategory) this.selectedGenres = this.genres[0] ? [this.genres[0].codename] : [];

				}

				this.lastCategoriesKey = categoriesKey;

				this.activeGenresByCategory = _.groupBy(_.filter(Metadata.Genres, genreProps => genreProps.active), genreProps => genreProps['category_codename']);

				this.previews = this.orderPreviews(_.filter(Preview.Previews, preview => {

					if (!preview["in_portfolio"]) return false;

					if (this.selectedCategories.length > 1) return this.selectedCategories.every(categoryCodename => this.isPreviewInCategory(preview, categoryCodename, this.activeGenresByCategory));

					if (this.selectedGenres.length) return this.selectedGenres.every(codename => preview.Genres[codename]);

					if (singleCategory) return this.isPreviewInCategory(preview, singleCategory, this.activeGenresByCategory);

					return true;

				}));

				this.genreFormats = _.orderBy(_.filter(Metadata.Genres, genreProps => (genreProps['category_codename'] === '') && genreProps.active), "priority");

				if (this.selectedFormats.length && this.selectedFormats.length < this.genreFormats.length) this.previews = _.filter(this.previews, preview => this.selectedFormats.some(codename => preview.Genres[codename]));

				this.tmpPreviews = this.orderPreviews(_.filter(Preview.Previews, preview => this.isTmpPreview(preview)));

				if (this.tmpPreviews.length > 0) this.categories.push({title: '###', codename: '#', data: {itemValue: '#'}});

				this.categoryChunks = [[], [], []];

				let partLength = 5;

				this.categoryChunks[0] = this.categories.slice(0, partLength);
				this.categoryChunks[1] = this.categories.slice(partLength, partLength * 2);
				this.categoryChunks[2] = this.categories.slice(partLength * 2);

			},
			isTmpPreview(preview) {

				return preview["in_portfolio"] && !_.find(_.keys(preview.Genres), genreCodename => Metadata.GenresByCodename[genreCodename]?.active);

			},
			isPreviewInCategory(preview, categoryCodename, activeGenresByCategory) {

				if (categoryCodename === '#') return this.isTmpPreview(preview);

				return !!activeGenresByCategory[categoryCodename]?.some(genre => preview.Genres[genre.codename]);

			},
			setCategory(categoryCodename) {

				// Клик по невыбранной категории - выбрать только её, по выбранной - убрать из комбинации
				if (this.selectedCategories.includes(categoryCodename)) this.selectedCategories = this.selectedCategories.filter(codename => codename !== categoryCodename);
				else this.selectedCategories = [categoryCodename];

				this.update();

			},
			canCombineCategory(categoryCodename) {

				const categories = [...this.selectedCategories, categoryCodename];

				let genres = [];

				if (categories.length === 1) {

					let categoryGenres = _.orderBy(_.filter(Metadata.Genres, genreProps => genreProps['category_codename'] === categoryCodename && genreProps.active), "priority");

					if (categoryGenres[0]) genres = [categoryGenres[0].codename];

				}

				return _.some(Preview.Previews, preview => {

					if (!preview["in_portfolio"]) return false;

					if (categories.length > 1) {

						if (!categories.every(c => this.isPreviewInCategory(preview, c, this.activeGenresByCategory))) return false;

					} else if (genres.length && !genres.every(codename => preview.Genres[codename])) return false;

					if (this.selectedFormats.length && this.selectedFormats.length < this.genreFormats.length && !this.selectedFormats.some(codename => preview.Genres[codename])) return false;

					return true;

				});

			},
			addCategoryToFilter(categoryCodename) {

				if (!this.canCombineCategory(categoryCodename)) return;

				if (!this.selectedCategories.includes(categoryCodename)) this.selectedCategories.push(categoryCodename);

				this.update();

			},
			setGenre(genreCodename) {

				// Клик по невыбранному жанру - выбрать только его, по выбранному - убрать из комбинации
				if (this.selectedGenres.includes(genreCodename)) this.selectedGenres = this.selectedGenres.filter(codename => codename !== genreCodename);
				else this.selectedGenres = [genreCodename];

				this.update();

			},
			canCombineGenre(genreCodename) {

				return this.previews.some(preview => preview.Genres[genreCodename]);

			},
			addGenreToFilter(genreCodename) {

				if (!this.canCombineGenre(genreCodename)) return;

				if (!this.selectedGenres.includes(genreCodename)) this.selectedGenres.push(genreCodename);

				this.update();

			},
			setFormat(genreCodename) {

				if (this.selectedFormats.includes(genreCodename)) this.selectedFormats = this.selectedFormats.filter(codename => codename !== genreCodename);
				else this.selectedFormats.push(genreCodename);

				this.update();

			},
			playVideo(event) {

				if (this.sortingMode) return;

				event.currentTarget.play();

			},
			stopVideo(event) {

				if (this.sortingMode) return;

				event.currentTarget.pause();

			},
			toggleFavorite(preview) {

				if (this.sortingMode) return;

				Server.sendToSocket({
					SetPreviewFavorite: {
						previewId: preview.id,
						isFavorite: !preview['is_favorite']
					}
				});

			},
			openPreview(preview) {

				if (this.sortingMode) return;

				Broadcast.call("Show Preview Settings", [preview]);

				//window.open(`${Metadata.Config["preview-url"]}${preview.hash}/`, "_blank");

			},
			toggleSortingMode() {

				this.sortingMode = !this.sortingMode;

			},
			publishPortfolio() {

				this.publishState = 'publishing';

				Server.sendToSocket({
					PublishPortfolio: {
						regenerateScreenshots: false
					}
				});

			},
			orderPreviews(previews) {

				return _.orderBy(previews, ['options.portfolioOrder', 'id']);

			},
			saveOrder() {

				const allPreviews = this.orderPreviews(_.filter(Preview.Previews, preview => preview["in_portfolio"])),
					visibleIds = this.previews.map(preview => preview.id),
					orderedVisible = this.previews.slice();

				allPreviews.forEach((preview, index) => {

					if (visibleIds.includes(preview.id)) preview = orderedVisible.shift();

					if (!preview.options) preview.options = {};

					preview.options.portfolioOrder = index;

				});

				this.$forceUpdate();

				Server.sendToSocket({
					SavePortfolioOrder: {
						previewsOrder: visibleIds
					}
				});

			},
			createPreviewFromUrl() {

				Server.sendToServer({
					CreatePreviewByURL: {
						url: this.url,
						genreCodename: this.selectedGenres[0]
					}
				});

				this.url = '';

			}
		}
	}
</script>


<style lang="sass">

	.preview-portfolio
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 0px

		.card
			margin: auto
			display: flex
			width: 1200px
			height: 750px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

		.form-line
			display: flex
			flex-direction: row

			.tabs .tab
				position: relative
				padding-right: 12px
				padding-left: 26px

				.title
					display: block
					overflow: hidden
					white-space: nowrap
					text-align: center

				i.fa.combine
					position: absolute
					left: 8px
					top: 50%
					transform: translateY(-50%)
					margin-right: 0
					margin-top: 0

		.tabs
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			justify-content: space-between
			align-items: center
			border: 1px solid #23282c
			border-radius: 4px
			user-select: none
			background: rgba(255, 255, 255, 0.2) no-repeat
			width: max-content

			.tab
				border: 1px dotted rgba(0,0,0,0.2)
				border-radius: 4px
				padding-top: 4px
				padding-bottom: 4px
				padding-right: 0.75rem
				padding-left: 0.75rem
				color: var(--secondary)
				cursor: pointer
				font-size: 13px
				text-transform: uppercase
				display: flex
				flex-direction: row-reverse
				justify-content: center
				align-items: center
				//width: 100%
				height: 33px
				white-space: nowrap
				margin: -1px

				.title
					display: flex
					height: 95%
					justify-content: center
					align-items: center
					padding-left: 1px
					padding-right: 1px

				i.fa
					margin-top: 2px

				i.fa.combine
					visibility: hidden
					margin-right: 6px

				i.fa.combine.disabled
					color: rgba(255, 255, 255, 0.2)
					cursor: default

			.tab:hover

				.title, i.fa
					color: white

				i.fa.combine
					visibility: visible

				i.fa.combine.disabled
					color: rgba(255, 255, 255, 0.2)

			.tab.selected
				border: 1px solid #2ac0f3
				background: rgba(0, 0, 0, 0.1) no-repeat

				.title, i.fa
					color: #2ac0f3

			.tab-separator
				width: 0
				height: 100%
				border-right: 1px solid rgba(0, 0, 0, 0.1)

		.tabs.formats
			margin-left: auto

			.tab
				padding-left: 12px

		.table
			display: table
			width: 100%

			.table-row
				display: table-row

				.table-cell
					display: table-cell
					text-align: center
					width: 20%

		.category-types .tab
			position: relative

			i.fa.combine
				position: absolute
				left: 8px
				top: 50%
				transform: translateY(-50%)
				margin-top: 0
				margin-right: 0

		.previews
			display: flex
			flex-direction: row
			flex-wrap: wrap
			justify-content: center
			align-items: center
			width: 100%
			height: 456px
			margin-top: 20px
			margin-bottom: 20px
			overflow-y: auto
			border-top: 1px solid rgba(0, 0, 0, 0.3)
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)

			.preview
				position: relative
				width: 142px
				height: 250px
				margin: 10px
				cursor: pointer
				perspective: 1000px

				.favorite-star
					position: absolute
					top: 5px
					right: 5px
					z-index: 2
					font-size: 18px
					color: var(--warning)
					text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.8)

					&.fa-star-o
						visibility: hidden

				.preview-inner
					position: relative
					width: 100%
					height: 100%
					transition: transform 0.6s
					transform-style: preserve-3d

					.preview-icon
						position: absolute
						left: 0
						top: 0
						width: 100%
						height: 100%
						background: white
						backface-visibility: hidden
						border-radius: 5px
						box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2)
						overflow: hidden

						img
							width: 100%

					.preview-video
						position: absolute
						left: 0
						top: 0
						width: 100%
						height: 100%
						backface-visibility: hidden
						background: #8b5cf6
						transform: rotateY(180deg)
						border-radius: 5px
						box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2)
						overflow: hidden

						video
							width: 100%

			.preview:hover

				.favorite-star.fa-star-o
					visibility: visible

				.preview-inner
					transform: rotateY(180deg)

			&.sorting

				.preview
					cursor: grab

				.preview:hover

					.preview-inner
						transform: none

		.form-actions
			display: flex
			flex-direction: row
			margin-top: 5px
			gap: 20px

			.btn-danger, .btn-primary, .btn-warning
				white-space: nowrap

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				margin-left: auto

			input.url
				width: 300px

			input::placeholder
				color: rgba(255,255,255,0.3)

</style>

